import { setFocus } from './setFocus';

export const Form = {
	setFocus
};
